import styled from "@emotion/styled";
import PropTypes from "prop-types";

import { HtmlContent } from "../../../HtmlContent";
import styles from "./Help.style";

const HelpStyled = styled.div((props) => ({ ...styles(props) }));

const Help = ({ text, className, ...rest }) => {
    if (!text) {
        return null;
    }

    return (
        <HelpStyled className={className} {...rest}>
            <HtmlContent content={text} className="inputHelpInner" wrapperComponent="div" />
        </HelpStyled>
    );
};

Help.propTypes = {
    text: PropTypes.string,
    className: PropTypes.string,
};

Help.defaultProps = {
    text: undefined,
    className: undefined,
};

export default Help;
